module.exports = __webpack_public_path__ + "static/media/market.c9380f5a.svg";